import firebase from "firebase";
import { serializer } from "./shared/serializer";

interface Organisation {
  id: string;
  baseUrl: string;
  name: string;
  listPremiumApps: Array<{
    name: string;
    packageName: string;
  }>;
}

const getOrganisationById = async (id) => {
  try {
    const qs = await firebase
      .firestore()
      .collection("organisations")
      .doc(id)
      .get();
    return serializer.documentSnapshotToDocument<Organisation>(qs);
  } catch (e) {
    console.error(e);
  }
};

export const organisations = {
  getOrganisationById
};
